import { getS3Link } from "@/services/api/agents/agents";
import { FolderOpenOutlined } from "@mui/icons-material";
import Button from "@mui/joy/Button";
import { useState } from "react";
import { toast } from "sonner";

interface FileViewButtonProps {
  file?: string | null;
  buttonText?: string;
}

const FileViewButton = ({ file, buttonText = "View" }: FileViewButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleViewFile = async () => {
    if (file && file.trim()) {
      try {
        setIsLoading(true);
        const link = await getS3Link(file);

        if (!link || link.trim() === "") {
          return;
        }

        window.open(link, "_blank");
      } catch (error) {
        toast.error("Error fetching file link");
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (!file || file.trim() === "") {
    return (
      <Button size="sm" variant="soft" disabled startDecorator={<FolderOpenOutlined />}>
        {buttonText}
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      variant="soft"
      color="primary"
      startDecorator={<FolderOpenOutlined />}
      style={{ width: "100%" }}
      onClick={handleViewFile}
      disabled={isLoading}
      loading={isLoading}
    >
      {buttonText}
    </Button>
  );
};

export default FileViewButton;
